module.exports = __webpack_public_path__ + "static/media/ic-medicine-patch.a30f5cc6.svg";